/**
 * Определяет живого игрока, который должен завершить этап ближнего боя бота.
 *
 * Если среди участников состоявшихся ближних боев (pendingMeleeDamage) есть отряды
 * живых игроков, этап завершает первый такой игрок по порядку в списке players —
 * одним нажатием на кнопку завершения за всех. Если участники только боты/нейтралы,
 * возвращает null (бот завершает этап сам).
 */
export const getHumanMeleeCompletingPlayer = (players, pendingMeleeDamage) => {
  if (!pendingMeleeDamage || pendingMeleeDamage.length === 0) {
    return null;
  }

  const participantOwnerIds = new Set(pendingMeleeDamage.map((action) => action.ownerId));

  return players.find((player) => !player.isBot && participantOwnerIds.has(player.id)) || null;
}
